export default __webpack_public_path__ + "static/media/trash-icon.8ee31a91.svg";